import axios, { AxiosError, AxiosResponse } from 'axios';
import User from '../../../models/User';
import { interceptor } from '../../../utils/axios.interceptor';
import { userEndPoint } from '../../../utils/endPoints';

export const userInstance = axios.create();
interceptor(userInstance);
export class UserService {
  /**
   * Used to create a user
   * @returns Create user response
   */
  async postUser(
    user: User,
  ): Promise<{ status: boolean; data: AxiosResponse | unknown }> {
    try {
      const body: User = {
        nombre: user.nombre,
        apellido: user.apellido,
        email: user.email,
        celular: user.celular,
        dni: user.dni,
        rolId: user.rolId === undefined ? (null as any) : user.rolId,
        notifProcesador: user.notifProcesador,
        accesoAdministracion: user.accesoAdministracion,
        accesoCatastro: user.accesoCatastro,
        accesoGestion: user.accesoGestion,
        accesoRegistros: user.accesoRegistros,
      };
      let result;
      const response = await userInstance.post(userEndPoint, body);
      if (response.status === 201) {
        result = { status: true, data: response.data };
      } else {
        result = { status: false, data: [] };
      }
      return result;
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
  /**
   * Used to get the users list
   * @returns users list
   */
  async getUsers(): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const response = await userInstance.get(userEndPoint);
      return {
        status: true,
        data: response.data.results,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
  /**
   * Used to update the user by id
   * @returns user object updated
   */
  async updateUser(user: User): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const body: User = {
        nombre: user.nombre,
        apellido: user.apellido,
        email: user.email,
        celular: user.celular,
        dni: user.dni,
        rolId: user.rolId,
        estado: user.estado,
        accesoAdministracion: user.accesoAdministracion,
        accesoGestion: user.accesoGestion,
        accesoCatastro: user.accesoCatastro,
        accesoRegistros: user.accesoRegistros,
      };
      const response = await userInstance.put(
        `${userEndPoint}/${user.id}`,
        body,
      );
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
  /**
   * Used to delete the user by id
   * @returns user object deleted
   */
  async deleteUser(user: User): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const response = await userInstance.delete(`${userEndPoint}/${user.id}`);
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
}
